import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Cashfreereturn from './mc/cashfree/Cashfreereturn';
import Chngpwd from './mc/Chngpwd';
import Footer from './mc/Footer';
import Home from './mc/Home';
import Login from './mc/Login';
// import Login from './mc/Loginv1';
import Loginv1 from './mc/Loginv1';
import MasterCityList from './mc/master/Master_City_List';
import MasterCountryList from './mc/master/Master_Country_List';
import MasterEntityContract from './mc/master/Master_Entity_Contract';
import MasterEntityList from './mc/master/Master_Entity_List';
import Master_Entity_Location from './mc/master/Master_Entity_Location';
import MasterGroupRightList from './mc/master/Master_GroupRight_List';
import MasterIsdList from './mc/master/Master_Isd_list';
import MasterIssuerList from './mc/master/Master_Issuer_List';
import MasterPurpose from './mc/master/Master_Purpose_List';
import MasterStateList from './mc/master/Master_State_List';
import MasterUserList from './mc/master/Master_User_List';
import Pgpine from './mc/pgpine/Pgpine';
import FullRateCard from './mc/rate/Full_Rate_Card';
import A2formv1 from './mc/reports/A2formv1';
import AgentBusinessReport from './mc/reports/AgentBusinessReport';
import AgentMisReport from './mc/reports/AgentMisReport';
import BookingReport from './mc/reports/BookingReport';
import Countrydiffer from './mc/reports/Countrydiffer';
import DealUsedReport from './mc/reports/DealUsed';
import Downloads from './mc/reports/Downloads';
import EnquiryDetail from './mc/reports/EnquiryDetail';
import EnquiryReport from './mc/reports/EnquiryReport';
import Extract from './mc/reports/Extract';
import InwardReport from './mc/reports/InwardReport';
import LoanReport from './mc/reports/LoanReport';
import LogReport from './mc/reports/LogReport';
import PaxListReport from './mc/reports/PaxListReport';
import PaymentReport from './mc/reports/PaymentReport';
import SpecialApproval from './mc/reports/SpecialApproval';
import SwiftDownload from './mc/reports/SwiftDownload';
import Transaction from './mc/reports/Transaction';
import UploadBankRefNo from './mc/reports/UploadBankRefNo';
import BookingModule from './mc/trans/BookingModule';
import EnquiryList from './mc/trans/EnquiryList';
import InProgress from './mc/trans/InProgress';
import InProgress1 from './mc/trans/InProgress1';
import InwardList from './mc/trans/InwardList';
import NewEnquiry from './mc/trans/NewEnquiry';
import NewRequest from './mc/trans/NewRequest';
import SampleForm from './mc/SampleForm';
import Master_individual_profile from './mc/master/Master_individual_profile';
import NewRequest_cn_vtm from './mc/trans/NewRequest_cn_vtm';
import Report from './mc/reports/Report';
import NewRequestCNCARD from './mc/trans/NewRequestCNCARD';
import Upload_utr from './mc/reports/Upload_utr';
import UtrBalance from './mc/reports/UtrBalance';
import Ad1 from './mc/trans/Ad1/Ad1';
import Ad2Modification from './mc/modification/ad2Modification';
import Bank_Charges_List from './mc/master/Bank_Charges_List';
// import Ad1 from './mc/reports/Ad1';

function App() {
  return (
    <div >
      <Routes>
        <Route exact path="/home" element={<Home />}></Route>
        <Route exact path="/changepassword" element={<Chngpwd />}></Route>
        <Route path="/" element={<Loginv1 />}></Route>
        <Route path="*" element={<Loginv1 />}></Route>
        <Route exact path="/login" element={<Loginv1 />}></Route>
        <Route exact path="/loginv0" element={<Login />}></Route>
        <Route exact path="/country-list" element={<MasterCountryList />}></Route>
        <Route exact path="/state-list" element={<MasterStateList />}></Route>
        <Route exact path="/city-list" element={<MasterCityList />}></Route>
        <Route exact path="/isd-list" element={<MasterIsdList />}></Route>
        <Route exact path="/issuer-list" element={<MasterIssuerList />}></Route>
        <Route exact path="/entity-list" element={<MasterEntityList />}></Route>
        <Route exact path="/right-list" element={<MasterGroupRightList />}></Route>
        <Route exact path="/user-list" element={<MasterUserList />}></Route>
        <Route exact path="/new-request" element={<NewRequest />}></Route>
        <Route exact path="/rate-card" element={<FullRateCard />}></Route>
        <Route exact path="/in-progress" element={<InProgress />}></Route>
        <Route exact path="/in-progress1" element={<InProgress1 />}></Route>
        <Route exact path="/entitycontract" element={<MasterEntityContract />}></Route>
        <Route exact path="/pg/:id" element={<Pgpine />}></Route>
        <Route exact path="/purpose" element={<MasterPurpose />}></Route>
        <Route exact path="/reptransaction" element={<Transaction />}></Route>
        <Route exact path="/repdataextract" element={<Extract />}></Route>
        <Route exact path="/replog" element={<LogReport />}></Route>
        <Route exact path="/repdealused" element={<DealUsedReport />}></Route>
        <Route exact path="/reppayment" element={<PaymentReport />}></Route>
        <Route exact path="/repbooking" element={<BookingReport />}></Route>
        <Route exact path="/repenquiry" element={<EnquiryReport />}></Route>
        <Route exact path="/new-enquiry" element={<NewEnquiry />} ></Route>
        <Route exact path="/enquiry-status" element={<EnquiryList />} ></Route>
        <Route exact path="/repupload" element={<UploadBankRefNo />} ></Route>
        <Route exact path="/swift" element={<SwiftDownload />} ></Route>
        <Route exact path="/loanreport" element={<LoanReport />} ></Route>
        <Route exact path="/inwardlist" element={<InwardList />} ></Route>
        <Route exact path="/inwardreport" element={<InwardReport />} ></Route>
        <Route exact path="/paxlistreport" element={<PaxListReport />} ></Route>
        <Route exact path="/downloads" element={<Downloads />} ></Route>
        <Route exact path="/cd/:id" element={<Countrydiffer />}></Route>
        <Route exact path="/cf/:orderid/:ordertoken" element={<Cashfreereturn />}></Route>
        <Route exact path="/ad1" element={<Ad1 />}></Route>
        {
          /**
            <Route exact path="/a2/:id" element={<A2form />}></Route>    
           */
        }

        <Route exact path="/a2v1/:paramType/:paramId" element={<A2formv1 />}></Route>
        <Route exact path="/enquirydetail" element={<EnquiryDetail />} ></Route>
        <Route exact path="/specialapproval" element={<SpecialApproval />} ></Route>
        <Route exact path="/misreport" element={<AgentMisReport />} ></Route>
        <Route exact path="/businessreport" element={<AgentBusinessReport />} ></Route>
        <Route exact path='/entitylocation' element={<Master_Entity_Location />}></Route>
        <Route exact path="/booking-module" element={<BookingModule />} ></Route>
        <Route exact path='/sample-page' element={<SampleForm />}></Route>
        <Route exact path='/individual-profile' element={<Master_individual_profile />}></Route>
        <Route exact path="/new-request-cn-vtm" element={<NewRequest_cn_vtm />}></Route>
        <Route exact path='/report' element={<Report />}></Route>
        <Route exact path='/new-request-cn-card' element={<NewRequestCNCARD />}></Route>
        <Route exact path='/upload-utr' element={<Upload_utr />}></Route>
        <Route exact path='/utr-utilization' element={<UtrBalance />}></Route>
        <Route exact path='/ad2-modification' element={<Ad2Modification />}></Route>
        <Route exact path='/charges' element={<Bank_Charges_List />}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;